// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highlight-parent span[data-v-0cd2fe46]{font-weight:600!important}.vesting-data[data-v-0cd2fe46]{display:grid;grid-gap:46px}@media (min-width:1256px){.vesting-data[data-v-0cd2fe46]{grid-template-columns:350px 1fr;direction:rtl}}@media (min-width:1420px){section:not(.in-modal)>.content>.vesting-data[data-v-0cd2fe46]{grid-template-columns:440px 1fr}}", ""]);
// Exports
module.exports = exports;
